import { Trans } from '@lingui/react/macro'
import { Button } from '@tecsinapse/cortex-react'
import React from 'react'
import { useToolbarActions } from '../hooks/use-toolbar-actions'
import { useToolbarElement } from '../hooks/use-toolbar-element'
import { MoverDialog } from './mover-dialog'
import { RenomearDialog } from './renomear-dialog'
import { ConcederAcessoDialog } from './conceder-acesso-dialog'
import { useRemover } from '../hooks/use-remover'
import { SelectedItemBiblioteca } from '@/modules/biblioteca-virtual/types/types'

const ToolbarElement = ({
  selectedRows,
  resetSelection
}: {
  selectedRows: SelectedItemBiblioteca[]
  resetSelection: () => void
}) => {
  const {
    pastasSelecionadas,
    isSelected,
    disabledRemove,
    disabledMove,
    disabledConcederAcesso,
    disabledRenomear,
    handleDownload
  } = useToolbarActions(selectedRows)

  const {
    setFolderToMove,
    folderToMove,
    folderToGrant,
    setFolderToGrant,
    folderToRename,
    setFolderToRename
  } = useToolbarElement()

  const { handleRemover } = useRemover({
    close: resetSelection
  })

  if (isSelected.length === 0) return null

  return (
    <div
      className='bg-primary-xlight border border-primary-light px-deca py-mili rounded-mili flex flex-row items-start text-white'
      data-testid='toolbar'
    >
      <Button
        variants={{ variant: 'text' }}
        onClick={() => {
          handleRemover(isSelected.map(rowData => rowData.data))
        }}
        disabled={disabledRemove()}
      >
        <Trans>Excluir</Trans>
      </Button>
      <Button
        variants={{ variant: 'text' }}
        onClick={() => setFolderToMove(isSelected.map(rowData => rowData.data))}
        disabled={disabledMove()}
        data-testid='move-button'
      >
        <p>
          <Trans>Mover</Trans>
        </p>
      </Button>
      <Button
        variants={{ variant: 'text' }}
        onClick={handleDownload}
        data-testid='download-button'
      >
        <Trans>Download</Trans>
      </Button>
      {pastasSelecionadas.length > 0 ? (
        <>
          <Button
            variants={{ variant: 'text' }}
            onClick={() => setFolderToGrant(isSelected[0].data)}
            disabled={disabledConcederAcesso()}
            data-testid='grant-button'
          >
            <Trans>Conceder Acesso</Trans>
          </Button>
          <Button
            variants={{ variant: 'text' }}
            onClick={() => {
              setFolderToRename(isSelected[0].data)
            }}
            disabled={disabledRenomear()}
            data-testid='rename-button'
          >
            <p>Renomear</p>
          </Button>
        </>
      ) : null}

      <RenomearDialog
        open={folderToRename !== undefined}
        close={() => {
          setFolderToRename(undefined)
          resetSelection()
        }}
        pastaAtual={folderToRename}
      />
      <MoverDialog
        open={folderToMove.length > 0}
        close={() => {
          setFolderToMove([])
          resetSelection()
        }}
        items={folderToMove}
      />
      <ConcederAcessoDialog
        open={folderToGrant !== undefined}
        close={() => {
          setFolderToGrant(undefined)
          resetSelection()
        }}
        pastaAtual={folderToGrant}
      />
    </div>
  )
}

export default ToolbarElement
